var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Manuals"},[_c('PlainNavBar'),_c('ParentPage',{staticClass:"Manuals",attrs:{"menu":_vm.menu,"rootRouteName":_vm.rootRouteName}}),_c('Overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }